<template>
  <v-card class="p-commentField" elevation="0" max-width="380">
    <comment-list
      v-for="(item, index) in existItems"
      :key="item.uuid"
      :item="item"
      :index='index'
    />
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import CommentList from '@/components/postEditor/parts/comments/CommentList'

export default {
  components: {
    CommentList
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post
    }),
    existItems: function () {
      return this.post.items.filter(item => !item._destroy)
    }
  }
}
</script>

<style scoped>
.p-commentField {
  display: flex;
  flex-direction: column;
}
</style>
